// Custom code for PDP product description read more           
const cardDescription = document.querySelectorAll(".product__description p");
const readMoreButton = document.querySelector(".read-more");

readMoreButton.addEventListener("click", function () {
  cardDescription.forEach(el => {
  el.classList.toggle("expanded");
  readMoreButton.textContent = el.classList.contains("expanded")
    ? "Read less"
    : "Read more";
  });   
});
// Custom code for PDP product description read more ends here

// Custom code to pass the value of quantity selector to the sticky ATC button form            
function passValue(val) {
  let updatedQuantity = val;
  // console.log(updatedQuantity);
  const qtyInput = document.getElementById("Quantity-sticky_cart");
  if (qtyInput) {
    qtyInput.value = updatedQuantity;
  }
  //document.getElementById("Quantity-sticky_cart").value = updatedQuantity;
} 
// Custom code to pass the value of quantity selector to the sticky ATC button form ends here

// Custom code to scroll down to judgeme reviews widget from review container
document.querySelector('.reviews_div').addEventListener('click', function() {
  var targetElement = document.getElementById('judgeme_product_reviews');
  var offsetTop = targetElement.offsetTop - 120;
  window.scrollTo({
    top: offsetTop,
    behavior: 'smooth'
  });
});
// Custom code to scroll down to judgeme reviews widget from review container ends here

// Custom code to lazy load judgeme product review img
const judgeme_image = document.querySelector('#judgeme_product_reviews .jdgm-rev img');
if (judgeme_image) {
  judgeme_image.setAttribute('loading', 'lazy');
  judgeme_image.setAttribute('fetchpriority', 'low');
}
// Custom code to lazy load judgeme product review img ends here